import { render, staticRenderFns } from "./OrderError.vue?vue&type=template&id=aa6b5700&scoped=true&"
import script from "./OrderError.vue?vue&type=script&lang=ts&"
export * from "./OrderError.vue?vue&type=script&lang=ts&"
import style0 from "./OrderError.vue?vue&type=style&index=0&id=aa6b5700&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6b5700",
  null
  
)

export default component.exports